import useTranslation from '@/hooks/useTranslation'
import ModelTypeCard from '@/components/themes/subaru/modelTypes/modelTypeCard'
import { GetImageByConfig } from '@/utils/productHelper'

const getModelImageUrl = ({ productImages, model, modelData, year }) =>
  modelData.reduce(
    (imageUrl, { modelType }) => imageUrl || GetImageByConfig(productImages, model, modelType, year),
    null
  )

const VehicleSelectorImageModel = ({ model, modelAlias, year, modelData, onClickModel, productImages }) => {
  const t = useTranslation()

  return (
    <ModelTypeCard
      modelType={model}
      imageUrl={getModelImageUrl({ productImages, model, modelData, year })}
      modelTypeTitle={modelAlias}
      onClickTrim={onClickModel}
      ariaLabel={t('select_vehicle_button_description', 'Select {{year}} {{model}} to view vehicle resources', {
        year,
        model: modelAlias
      })}
    />
  )
}

export default VehicleSelectorImageModel
